module.exports = __webpack_public_path__ + "static/media/video-benefits.174b6fa5.png";